
import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, makeStyles, Typography, withStyles } from '@material-ui/core';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';

const useStyles = makeStyles((theme) => ({
	darkAccordion: {
		backgroundColor: '#31264a', // تغییر رنگ پس زمینه به رنگ تیره
		color: theme.palette.common.white, // تغییر رنگ متن به سفید
		marginBottom: theme.spacing(1),

		'& .MuiTypography-root': {
			fontFamily: 'inherit !important',
		},

	},
	darkHeader: {
		backgroundColor: '#524966', // تغییر رنگ بخش کلی به مشکی
	},
	accordionDetails: {
		'& .MuiTypography-root': {
			fontSize: '0.9rem',
		},
	},
}));

export default function Faq () {
	useEffect(() => {
		setTitle('سوالات متداول');
	}, []);

	const classes = useStyles();
	const [expanded, setExpanded] = useState('panel1');

	const faqList = [
		{
			title: 'نحوه ثبت نام در ببین چگونه است؟',
			description: 'ثبت نام ببین رایگان بوده و با شماره موبایل انجام می گیرد. با زدن دکمه پروفایل و ورود یا ثبت نام، با وارد کردن شماره ایران و وارد کردن کد پیامک شده، وارد حساب کاربری می شود.'
		},
		{
			title: 'شماره موبایل را قبول نمی کند، مشکل چیست؟',
			description: 'حتما شماره را به صورت استاندارد صحیح و با کیبورد انگلیسی وارد کنید. نمونه: 09123456789'
		},
		{
			title: 'آیا برای تماشای فیلم‌ها و سریال ها، باید اشتراک خریداری کرد؟',
			description: 'خیر؛ ببین کاملا به صورت رایگان بوده و نیاز به تهیه اشتراک جهت تماشا یا دانلود فیلم ها یا سریال ها ندارد.'
		},
		{
			title: ' آیا خارج از ایران ببین در دسترس است؟',
			description: 'در حال حاضر خیر و فقط از داخل ایران و با شماره موبایل ایران قابل دسترس است.'
		},
		{
			title: ' آیا می‌توان فیلم ها یا سریال ها رو دانلود کرد؟',
			description: 'بله امکان دانلود محتوا در ببین امکان پذیر است.'
		},
		{
			title: 'آیا امکان پخش ببین در تلویزون وجود دارد؟',
			description: 'بله؛ در صورت داشتن تلویزون اندروید می توانید از نرم افزار ببین که در کافه بازار موجود است استفاده کنید. در صورت داشتن حالت Mirror Screen در تلفن همراه خود نیز می توانید ببین را در تلویزون مشاهده کنید.'
		},
		{
			title: 'ببین از چه طریق هایی در دسترس است؟',
			description: 'در حال حاضر ببین از طریق نرم افزار اندروید و وب سایت در دسترس می باشد.'
		},
		{
			title: 'راه ارتباط با پشتیبانی ببین از چه طریقی است؟',
			description: 'در صورت داشتن مشکل می توانید از طریق ایمیل info@bebin.com با ما در ارتباط باشید.'
		},
	]

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	return (
		<>
			<div className="container" style={{ margin: '30px auto' }}>
				<br />
				<br />
				<div className="max-width-menu section-title clearfix"><h1>سوالات متداول</h1></div>
				{
					faqList.map((faq, index) => {
						return <Accordion className={classes.darkAccordion} square
										  expanded={expanded === `panel${index + 1}`}
										  onChange={handleChange(`panel${index + 1}`)}>
							<AccordionSummary className={classes.darkHeader}
											  aria-controls={`panel${index + 1}d-content`}
											  id={`panel${index + 1}d-header`}>
								<Typography>{faq.title}</Typography>
							</AccordionSummary>
							<AccordionDetails className={classes.accordionDetails}>
								<Typography>
									{faq.description}
								</Typography>
							</AccordionDetails>
						</Accordion>
					})
				}
			</div>
			<Footer></Footer>
		</>
	);
}
